<script>
import {defineComponent} from 'vue'
import {useCallbackStore} from "@js/store/CallbackStore.js";
import IconSearch from "@js/components/Icons/IconSearch.vue";

export default defineComponent({
    name: "CantFindProduct",
    components: {IconSearch},
    setup() {
        const callbackStore = useCallbackStore()

        return {callbackStore}
    }
})
</script>

<template>
    <div @click.prevent="callbackStore.showBaseCallbackPopup?.({
                                title: 'Обратный звонок',
                                bitrix_title: 'Заказ обратного звонка с сайта Вторчермет-1',
                                })"
         class="w-full px-5 py-3 border rounded-xl border-dashed border-gray-400 flex items-center justify-center cursor-pointer bg-transparent sm:hover:bg-gray-100 transition">
        <div class="flex items-center gap-5 text-gray-700">
            <IconSearch class="w-8 h-8"/>
            <div>
                <p class="text-nowrap font-bold">
                    Не нашли нужный товар?
                </p>
                <p class="text-nowrap text-sm font-medium">
                    Наш оператор вас проконсультирует
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
